module.exports = "/images/laser tag (flatten).svg?5371ed0e93e4e30dcfedcff9f6364138";